/**
 * Unified file uploader for Hifireels. Uploads to Emergent Object Store via
 * the backend `/api/upload/file` endpoint. Returns a Cloudinary-compatible shape
 * (secure_url, public_id, duration, bytes, format) so existing call sites keep working.
 */
const BASE = process.env.REACT_APP_BACKEND_URL || "";

/**
 * @param {File} file – the file to upload
 * @param {string} folder – logical folder, e.g. "reels" | "images" | "music" | "templates"
 * @param {(pct:number)=>void} onProgress – called with progress percentage 0–100
 * @returns Promise resolving to {secure_url, public_id, duration?, size, format, kind}
 */
export function uploadToStorage(file, folder = "uploads", onProgress) {
  return new Promise((resolve, reject) => {
    if (!file) return reject(new Error("No file provided"));
    const fd = new FormData();
    fd.append("file", file);
    const xhr = new XMLHttpRequest();
    xhr.open("POST", `${BASE}/api/upload/file?folder=${encodeURIComponent(folder)}`);
    const tok = localStorage.getItem("hf_token");
    if (tok) xhr.setRequestHeader("Authorization", "Bearer " + tok);
    xhr.upload.onprogress = (e) => {
      if (e.lengthComputable && onProgress) onProgress(Math.round((e.loaded / e.total) * 100));
    };
    xhr.onload = () => {
      try {
        const data = JSON.parse(xhr.responseText);
        if (xhr.status >= 200 && xhr.status < 300) {
          resolve({
            secure_url: data.secure_url || data.url,
            url: data.secure_url || data.url,
            public_id: data.path,
            duration: data.duration || 0,
            bytes: data.size,
            size: data.size,
            format: data.format,
            kind: data.kind,
          });
        } else reject(new Error(data?.detail || "Upload failed"));
      } catch { reject(new Error("Upload failed")); }
    };
    xhr.onerror = () => reject(new Error("Network error"));
    xhr.send(fd);
  });
}
